import React, { useState, useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import cx from 'classnames';
import styles from './index.module.scss.js';

const PaginationLocal = ({
  perPage = 9,
  data = [],
  v2,
  onChangePage,
  className
}) => {
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const handlePageClick = (event) => {
    const newOffset = event.selected * perPage % data.length;
    setItemOffset(newOffset);
  };
  useEffect(() => {
    const endOffset = itemOffset + perPage;
    onChangePage(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / perPage));
  }, [itemOffset, perPage, data]);
  if (data.length < perPage) return null;
  return /* @__PURE__ */ React.createElement(
    ReactPaginate,
    {
      breakLabel: "...",
      onPageChange: handlePageClick,
      pageRangeDisplayed: 1,
      pageCount,
      initialPage: 0,
      renderOnZeroPageCount: null,
      className: cx(styles.box, className, {
        [styles.v2]: v2
      }),
      previousClassName: styles["prev-btn"],
      nextClassName: styles["next-btn"],
      pageClassName: styles.page
    }
  );
};
PaginationLocal.displayName = "PaginationLocal";

export { PaginationLocal };
//# sourceMappingURL=index.js.map
